<template>
	<el-dialog title="" :show-close='false' width="30%" center :visible="show" >
		<span class="type_size_22">作业已做完，是否确认提交</span>
		<div class="p_flex p_f_c p_m_t_30">
			<el-button  @click="close" type="info">取消</el-button>
			<el-button  @click="goButton" type="success">确认</el-button>
			</div>
	</el-dialog>
</template>

<script>
export default {
	props:{
		show:null
	},
	data() {
		return {
			exerciseBook:'',
		};
	},
	mounted() {
	},
	methods: {
		close() {
			this.$emit('closes', false);
		},
		goButton(){
			this.$emit('goButton', false);
		}
	}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/homes/stay/commponents/popUp.vue